<template>
  <div class="d-flex new-powered-by">
    <h5 class="powered-by-text">{{ $t("poweredBy") }}</h5>
    <img :src="imageUrl" />
  </div>
</template>

<script>
export default {
  name: "NewPoweredBy",
  data() {
    return {
      imageUrl: `https://hub.swiset.com/wp-content/uploads/2024/01/Swiset-Logo-SVG-for-${this.$vuetify.theme.dark ? "Dark" : "Light"
        }.png`,
      ctaUrl: "https://swiset.com",
    };
  },
  methods: {
    ctaClick() {
      window.open(this.ctaUrl);
    },
  },
};
</script>

<style lang="scss">
.new-powered-by {
  display: flex;
  flex-direction: column;
  .powered-by-text {
    color: var(--mediumGrey);
    /* Regular/Label */
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    color: #9A9A9A;
    margin-bottom: 10px;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  img {
    width: 160px;
  }

  @media (max-width: 768px) {
    img {
      width: 140px;
    }
  }

}
</style>


